import Component from '../../shared/component';

export default class FeaturedRecordsCarousel extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);

    this.addClasses();
    this.bindEvents();
  }

  bindEvents() {
    this.$element.owlCarousel({
      items: 1,
      autoplay: true,
      loop: true,
      autoplayHoverPause: true,
    });

    this.$owl = this.$element.data('owl.carousel');
  }

  unbindEvents() {
    this.$owl.destroy();
  }

  addClasses() {
    this.$element.addClass('owl-carousel');
    this.$element.addClass('owl-theme');
  }
}
